import { useNavigate } from "react-router-dom";
import ActionMenu, {
  ActionMenuItem,
} from "../../../../../components/actionMenu/ActionMenu";
import { FleetDataInterface } from "../../../../../redux/interfaces/fleet.interface";
import { setFleetCarData } from "../../../../../redux/reducer/fleet.reducer";
import { crudRoutes, fleetRoutes } from "../../../../../router/routesConstants";
import { useAppDispatch } from "../../../../../redux/hooks";
import { fetchDeleteCar } from "../../../../../redux/api/fleet.api";
import usePermissions from "../../../../../router/usePermissions";
import userRoles from "../../../../../constants/userRoles";

function FleetActionButton({
  itemId,
  crudData,
  tableContext,
}: {
  itemId: string;
  crudData: FleetDataInterface;
  tableContext: any;
}) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isAuthorized } = usePermissions();

  const {
    CAR_DELETE_PERMISSION,
    CAR_DOCUMENTS_ALL_PERMISSION,
    CAR_DOCUMENTS_PERMISSION,
    CAR_EDIT_PERMISSION,
    CAR_FEATURES_PERMISSION,
  } = {
    CAR_EDIT_PERMISSION: isAuthorized(userRoles.CAR_EDIT),
    CAR_DELETE_PERMISSION: isAuthorized(userRoles.CAR_DELETE),
    CAR_FEATURES_PERMISSION: isAuthorized(userRoles.CAR_FEATURES_DISPLAY),
    CAR_DOCUMENTS_PERMISSION: isAuthorized(userRoles.CAR_DOCUMENTS_DISPLAY),
    CAR_DOCUMENTS_ALL_PERMISSION: isAuthorized(
      userRoles.CAR_DOCUMENTS_ALL_DISPLAY,
    ),
  };

  const handleEdit = () => {
    dispatch(setFleetCarData(crudData));
    navigate(`${itemId}/${crudRoutes.edit}?nrauto=${crudData.nrauto}`);
  };

  const handleGoToFeatures = () => {
    dispatch(setFleetCarData(crudData));
    navigate(`${itemId}/${fleetRoutes.features}?nrauto=${crudData.nrauto}`);
  };

  const handleGoToDocuments = () => {
    dispatch(setFleetCarData(crudData));
    navigate(`${itemId}/${fleetRoutes.documents}?nrauto=${crudData.nrauto}`);
  };

  const handleGoToAllDocuments = () => {
    dispatch(setFleetCarData(crudData));
    navigate(`${itemId}/${fleetRoutes.allDocumets}?nrauto=${crudData.nrauto}`);
  };

  const handleDelete = () => {
    dispatch(
      fetchDeleteCar({
        id: itemId,
        page: tableContext.page,
        perPage: tableContext.perPage,
      }),
    );
  };

  const items: ActionMenuItem[] = [
    {
      id: "edit",
      label: "Editeaza autovehicul",
      section: "manage",
      icon: "EDIT",
      tooltip: "Deschide editarea datelor autovehiculului.",
      hidden: !CAR_EDIT_PERMISSION,
      onClick: handleEdit,
    },
    {
      id: "features",
      label: "Echipamente calitate transport",
      section: "browse",
      icon: "SENSORS",
      tooltip: "Afiseaza echipamentele de calitate ale autovehiculului.",
      hidden: !CAR_FEATURES_PERMISSION,
      onClick: handleGoToFeatures,
    },
    {
      id: "documents",
      label: "Documente",
      section: "browse",
      icon: "DOCUMENTS",
      tooltip: "Afiseaza documentele autovehiculului.",
      hidden: !CAR_DOCUMENTS_PERMISSION,
      onClick: handleGoToDocuments,
    },
    {
      id: "all-documents",
      label: "Toate documentele",
      section: "browse",
      icon: "MULTIPLE_DOCUMENTS",
      tooltip:
        "Afiseaza toate documentele autovehiculului si ale echipamentelor sale.",
      hidden: !CAR_DOCUMENTS_ALL_PERMISSION,
      onClick: handleGoToAllDocuments,
    },
    {
      id: "delete",
      label: "Sterge autovehiculul",
      section: "danger",
      icon: "DELETE",
      color: "error",
      tooltip:
        "Sterge datele de identificare ale autovehiculului, dupa confirmare.",
      hidden: !CAR_DELETE_PERMISSION,
      withConfirmationModal: {
        modalTitle: `Doriti sa stergeti datele de identificare pt. autoturismul cu nr. de inmatriculare ${crudData.nrauto}?`,
        modalLeftButtonColor: "inherit",
        modalRightButtonOnClick: handleDelete,
        modalRightButtonText: "Sterge",
        modalRightButtonColor: "error",
        modalLeftButtonText: "Anuleaza",
      },
    },
  ];

  return (
    <ActionMenu
      items={items}
      minItemsForMenu={2}
      title={crudData.nrauto}
      ariaLabel={`Actiuni pentru autovehiculul ${crudData.nrauto}`}
    />
  );
}

export default FleetActionButton;
